module.exports = __webpack_public_path__ + "img/no-filter.70a30623.jpg";